import { Dispatch, SetStateAction } from 'react'

import * as E from 'types/enums'

export interface IRange {
  min?: number
  max?: number
}

export interface IPrice {
  min?: number
  max?: number
}

export type ForSaleType = 'For Sale' | 'In Contract' | 'Sold'

export enum ForSaleTypeEnum {
  forSale = 'For Sale',
  inContract = 'In Contract',
  sold = 'Sold',
}

export enum MobileFilterSheetName {
  homeType = 'homeType',
  price = 'price',
  moreFilters = 'moreFilters',
}

export interface IFilterProps {
  hide?: boolean
}

export interface IMobileSheetProps {
  visible: boolean
  showMobileFilterSheet: () => void
  hideMobileFilterSheet: () => void
}

export interface IForSaleTypeProps {
  selectedForSaleTypes: ForSaleType[]
  setSelectedForSaleTypes: Dispatch<SetStateAction<ForSaleType[]>>
  applyForSaleTypeSelection: () => void
  resetForSaleTypeSelection: () => void
}

export interface IPriceRangeProps {
  selectedPriceRange: IRange
  setSelectedPriceRange: Dispatch<SetStateAction<IRange>>
  applyPriceRangeSelection: () => void
  resetPriceRangeSelection: () => void
}

export interface IHomeTypeProps {
  selectedHomeTypes: E.HomeTypeEnum[]
  setSelectedHomeTypes: Dispatch<SetStateAction<E.HomeTypeEnum[]>>
  applyHomeTypeSelections: () => void
  resetHomeTypeSelections: () => void
}

export interface IBedProps {
  selectedBedRange: IRange
  setSelectedBedRange: Dispatch<SetStateAction<IRange>>
  applyBedSelections: () => void
  resetBedSelections: () => void
}

export interface IBathProps {
  selectedBathRange: IRange
  setSelectedBathRange: Dispatch<SetStateAction<IRange>>
  applyBathSelections: () => void
  resetBathSelections: () => void
}
